import script from "./UserAvailableCounselling.vue?vue&type=script&setup=true&lang=js"
export * from "./UserAvailableCounselling.vue?vue&type=script&setup=true&lang=js"

import "./UserAvailableCounselling.vue?vue&type=style&index=0&id=5411ef46&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5411ef46"]])

export default __exports__